import { setup } from './index';

setup();
